import React from 'react'
import { BuilderComponent } from '@builder.io/react'
import SEO from '../components/shared/SEO'
import { getSymbolsBlockContentFromBuilderData } from '../builder/utils/builder'

const BuilderPageTemplate = ({ pageContext }) => {
    const { published, content, model, symbol } = pageContext
    const resolvedBlocks = getSymbolsBlockContentFromBuilderData(
        content?.data,
        symbol
    )
    const newContentWithSymbol = {
        ...content,
        data: { ...content.data, blocks: resolvedBlocks },
    }
    return (
        <main>
            <div className="hero py-0">
                {published ? (
                    <>
                        {content && (
                            <BuilderComponent
                                model={model}
                                content={newContentWithSymbol}
                                options={{ cachebust: true }}
                            />
                        )}
                    </>
                ) : (
                    <p>This page is not published.</p>
                )}
            </div>
        </main>
    )
}

export default BuilderPageTemplate

export const Head = ({ location, pageContext }) => {
    const { origin, title, description } = pageContext
    return (
        <SEO
            origin={origin}
            location={location}
            title={title}
            description={description}
        />
    )
}
